function shorthand(mapping) {
  return function(arg) {
    var target = {};
    for (var short in arg) {
      var long = mapping[short];
      if (long) {
        target[long] = arg[short];
      }
    }
    return target;
  }
}

/**
 * Shorthand animation helper
 * @function animation
 * @param  {object}         value
 * @param  {number|string} [value.name]           animation name value
 * @param  {number|string} [value.duration]       animation duration value
 * @param  {number|string} [value.timingFunction] animation timingFunction value
 * @param  {number|string} [value.delay]          animation delay value
 * @param  {number|string} [value.iterationCount] animation iterationCount value
 * @param  {number|string} [value.direction]      animation direction value
 * @param  {number|string} [value.fillMode]       animation fillMode value
 * @param  {number|string} [value.playState]      animation playState value
 * @return {object}                                Style object
 * @example
 * // A single property
 * animation({name: 'foo'});
 * // → {
 * //     animationName: 'foo'
 * //   }
 * @example
 * // Multiple properties
 * animation({name: 'foo', duration: 'bar'});
 * // → {
 * //     animationName: 'foo',
 * //     animationDuration: 'bar'
 * //   }
 */
var animation = shorthand({
  name: 'animationName',
  duration: 'animationDuration',
  timingFunction: 'animationTimingFunction',
  delay: 'animationDelay',
  iterationCount: 'animationIterationCount',
  direction: 'animationDirection',
  fillMode: 'animationFillMode',
  playState: 'animationPlayState'
});

/**
 * Shorthand background helper
 * @function background
 * @param  {object}         value
 * @param  {number|string} [value.image]      background image value
 * @param  {number|string} [value.position]   background position value
 * @param  {number|string} [value.size]       background size value
 * @param  {number|string} [value.repeat]     background repeat value
 * @param  {number|string} [value.origin]     background origin value
 * @param  {number|string} [value.clip]       background clip value
 * @param  {number|string} [value.attachment] background attachment value
 * @param  {number|string} [value.color]      background color value
 * @return {object}                            Style object
 * @example
 * // A single property
 * background({image: 'foo'});
 * // → {
 * //     backgroundImage: 'foo'
 * //   }
 * @example
 * // Multiple properties
 * background({image: 'foo', position: 'bar'});
 * // → {
 * //     backgroundImage: 'foo',
 * //     backgroundPosition: 'bar'
 * //   }
 */
var background = shorthand({
  image: 'backgroundImage',
  position: 'backgroundPosition',
  size: 'backgroundSize',
  repeat: 'backgroundRepeat',
  origin: 'backgroundOrigin',
  clip: 'backgroundClip',
  attachment: 'backgroundAttachment',
  color: 'backgroundColor'
});

function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}

function directional(top, right, bottom, left) {
  return function(arg) {
    var target = {};
    if (typeof arg === 'object' && arg !== null) {
      if (arg.x) { target[left] = arg.x; target[right] = arg.x; }
      if (arg.y) { target[top] = arg.y, target[bottom] = arg.y; }
      if (arg.top) { target[top] = arg.top; }
      if (arg.right) { target[right] = arg.right; }
      if (arg.bottom) { target[bottom] = arg.bottom; }
      if (arg.left) { target[left] = arg.left; }
      return target;
    }
    target[top] = arg;
    target[right] = arg;
    target[bottom] = arg;
    target[left] = arg;
    return target;
  }
}

/**
 * Directional borderColor helper
 * @function borderColor
 * @param  {number|string|object} value         Value for all directions or object of values:
 * @param  {number|string}       [value.x]      Left and right value
 * @param  {number|string}       [value.y]      Top and bottom value
 * @param  {number|string}       [value.top]    Top value (takes precedence over y)
 * @param  {number|string}       [value.right]  Right value (takes precedence over x)
 * @param  {number|string}       [value.bottom] Bottom value (takes precedence over y)
 * @param  {number|string}       [value.left]   Left value (takes precedence over x)
 * @return {object}                             Style object
 * @example
 * // All directions
 * borderColor('foo');
 * // → {
 * //     borderTopColor: 'foo',
 * //     borderRightColor: 'foo',
 * //     borderBottomColor: 'foo',
 * //     borderLeftColor: 'foo'
 * //   }
 * @example
 * // A single axis
 * borderColor({x: 'bar'});
 * // → {
 * //     borderLeftColor: 'bar',
 * //     borderRightColor: 'bar'
 * //   }
 * @example
 * // Any combination
 * borderColor({y: 'foo', top: 'bar', right: 'baz'});
 * // → {
 * //     borderTopColor: 'bar',
 * //     borderRightColor: 'baz',
 * //     borderBottomColor: 'foo'
 * //   }
 */
var borderColor = directional(
  'borderTopColor',
  'borderRightColor',
  'borderBottomColor',
  'borderLeftColor'
);

/**
 * Directional borderStyle helper
 * @function borderStyle
 * @param  {number|string|object} value         Value for all directions or object of values:
 * @param  {number|string}       [value.x]      Left and right value
 * @param  {number|string}       [value.y]      Top and bottom value
 * @param  {number|string}       [value.top]    Top value (takes precedence over y)
 * @param  {number|string}       [value.right]  Right value (takes precedence over x)
 * @param  {number|string}       [value.bottom] Bottom value (takes precedence over y)
 * @param  {number|string}       [value.left]   Left value (takes precedence over x)
 * @return {object}                             Style object
 * @example
 * // All directions
 * borderStyle('foo');
 * // → {
 * //     borderTopStyle: 'foo',
 * //     borderRightStyle: 'foo',
 * //     borderBottomStyle: 'foo',
 * //     borderLeftStyle: 'foo'
 * //   }
 * @example
 * // A single axis
 * borderStyle({x: 'bar'});
 * // → {
 * //     borderLeftStyle: 'bar',
 * //     borderRightStyle: 'bar'
 * //   }
 * @example
 * // Any combination
 * borderStyle({y: 'foo', top: 'bar', right: 'baz'});
 * // → {
 * //     borderTopStyle: 'bar',
 * //     borderRightStyle: 'baz',
 * //     borderBottomStyle: 'foo'
 * //   }
 */
var borderStyle = directional(
  'borderTopStyle',
  'borderRightStyle',
  'borderBottomStyle',
  'borderLeftStyle'
);

/**
 * Directional borderWidth helper
 * @function borderWidth
 * @param  {number|string|object} value         Value for all directions or object of values:
 * @param  {number|string}       [value.x]      Left and right value
 * @param  {number|string}       [value.y]      Top and bottom value
 * @param  {number|string}       [value.top]    Top value (takes precedence over y)
 * @param  {number|string}       [value.right]  Right value (takes precedence over x)
 * @param  {number|string}       [value.bottom] Bottom value (takes precedence over y)
 * @param  {number|string}       [value.left]   Left value (takes precedence over x)
 * @return {object}                             Style object
 * @example
 * // All directions
 * borderWidth('foo');
 * // → {
 * //     borderTopWidth: 'foo',
 * //     borderRightWidth: 'foo',
 * //     borderBottomWidth: 'foo',
 * //     borderLeftWidth: 'foo'
 * //   }
 * @example
 * // A single axis
 * borderWidth({x: 'bar'});
 * // → {
 * //     borderLeftWidth: 'bar',
 * //     borderRightWidth: 'bar'
 * //   }
 * @example
 * // Any combination
 * borderWidth({y: 'foo', top: 'bar', right: 'baz'});
 * // → {
 * //     borderTopWidth: 'bar',
 * //     borderRightWidth: 'baz',
 * //     borderBottomWidth: 'foo'
 * //   }
 */
var borderWidth = directional(
  'borderTopWidth',
  'borderRightWidth',
  'borderBottomWidth',
  'borderLeftWidth'
);

/**
 * Directional borderRadius helper
 * @function borderRadius
 * @param  {number|string|object} value         Value for all directions or object of values:
 * @param  {number|string}       [value.x]      Left and right value
 * @param  {number|string}       [value.y]      Top and bottom value
 * @param  {number|string}       [value.top]    Top value (takes precedence over y)
 * @param  {number|string}       [value.right]  Right value (takes precedence over x)
 * @param  {number|string}       [value.bottom] Bottom value (takes precedence over y)
 * @param  {number|string}       [value.left]   Left value (takes precedence over x)
 * @return {object}                             Style object
 * @example
 * // All directions
 * borderRadius('foo');
 * // → {
 * //     borderTopRadius: 'foo',
 * //     borderRightRadius: 'foo',
 * //     borderBottomRadius: 'foo',
 * //     borderLeftRadius: 'foo'
 * //   }
 * @example
 * // A single axis
 * borderRadius({x: 'bar'});
 * // → {
 * //     borderLeftRadius: 'bar',
 * //     borderRightRadius: 'bar'
 * //   }
 * @example
 * // Any combination
 * borderRadius({y: 'foo', top: 'bar', right: 'baz'});
 * // → {
 * //     borderTopRadius: 'bar',
 * //     borderRightRadius: 'baz',
 * //     borderBottomRadius: 'foo'
 * //   }
 */
var borderRadius = directional(
  'borderTopRadius',
  'borderRightRadius',
  'borderBottomRadius',
  'borderLeftRadius'
);

/**
 * Shorthand border helper
 * @function border
 * @param  {object}  value
 * @param  {number|string|object} [value.color]  border color value (see {@link borderColor})
 * @param  {number|string|object} [value.style]  border style value (see {@link borderStyle})
 * @param  {number|string|object} [value.width]  border width value (see {@link borderWidth})
 * @param  {number|string|object} [value.radius] border radius value (see {@link borderRadius})
 * @return {object}                              Style object
 * @example
 * // A single property in all directions
 * border({color: 'red'});
 * // → {
 * //     borderTopColor: 'red',
 * //     borderRightColor: 'red',
 * //     borderBottomColor: 'red',
 * //     borderLeftColor: 'red'
 * //   }
 * @example
 * // Any combination
 * border({color: 'red', width: {y: '2px', right: '8px'}});
 * // → {
 * //     borderTopColor: 'red',
 * //     borderRightColor: 'red',
 * //     borderBottomColor: 'red',
 * //     borderLeftColor: 'red',
 * //     borderTopWidth: '2px',
 * //     borderRightWidth: '8px',
 * //     borderBottomWidth: '2px'
 * //   }
 */
function border(arg) {
  return assign({},
    arg.color && borderColor(arg.color),
    arg.style && borderStyle(arg.style),
    arg.width && borderWidth(arg.width),
    arg.radius && borderRadius(arg.radius)
  );
}

/**
 * Shorthand borderImage helper
 * @function borderImage
 * @param  {object}         value
 * @param  {number|string} [value.source] borderImage source value
 * @param  {number|string} [value.slice]  borderImage slice value
 * @param  {number|string} [value.width]  borderImage width value
 * @param  {number|string} [value.outset] borderImage outset value
 * @param  {number|string} [value.repeat] borderImage repeat value
 * @return {object}                        Style object
 * @example
 * // A single property
 * borderImage({source: 'foo'});
 * // → {
 * //     borderImageSource: 'foo'
 * //   }
 * @example
 * // Multiple properties
 * borderImage({source: 'foo', slice: 'bar'});
 * // → {
 * //     borderImageSource: 'foo',
 * //     borderImageSlice: 'bar'
 * //   }
 */
var borderImage = shorthand({
  source: 'borderImageSource',
  slice: 'borderImageSlice',
  width: 'borderImageWidth',
  outset: 'borderImageOutset',
  repeat: 'borderImageRepeat'
});

/**
 * Shorthand flex helper
 * @function flex
 * @param  {object}         value
 * @param  {number|string} [value.grow]   flex grow value
 * @param  {number|string} [value.shrink] flex shrink value
 * @param  {number|string} [value.basis]  flex basis value
 * @return {object}                        Style object
 * @example
 * // A single property
 * flex({grow: 'foo'});
 * // → {
 * //     flexGrow: 'foo'
 * //   }
 * @example
 * // Multiple properties
 * flex({grow: 'foo', shrink: 'bar'});
 * // → {
 * //     flexGrow: 'foo',
 * //     flexShrink: 'bar'
 * //   }
 */
var flex = shorthand({
  grow: 'flexGrow',
  shrink: 'flexShrink',
  basis: 'flexBasis'
});

/**
 * Shorthand font helper
 * @function font
 * @param  {object}         value
 * @param  {number|string} [value.style]   font style value
 * @param  {number|string} [value.variant] font variant value
 * @param  {number|string} [value.weight]  font weight value
 * @param  {number|string} [value.stretch] font stretch value
 * @param  {number|string} [value.size]    font size value
 * @param  {number|string} [value.family]  font family value
 * @return {object}                         Style object
 * @example
 * // A single property
 * font({style: 'foo'});
 * // → {
 * //     fontStyle: 'foo'
 * //   }
 * @example
 * // Multiple properties
 * font({style: 'foo', variant: 'bar'});
 * // → {
 * //     fontStyle: 'foo',
 * //     fontVariant: 'bar'
 * //   }
 */
var font = shorthand({
  style: 'fontStyle',
  variant: 'fontVariant',
  weight: 'fontWeight',
  stretch: 'fontStretch',
  size: 'fontSize',
  family: 'fontFamily'
});

/**
 * Shorthand listStyle helper
 * @function listStyle
 * @param  {object}         value
 * @param  {number|string} [value.type]     listStyle type value
 * @param  {number|string} [value.position] listStyle position value
 * @param  {number|string} [value.image]    listStyle image value
 * @return {object}                          Style object
 * @example
 * // A single property
 * listStyle({type: 'foo'});
 * // → {
 * //     listStyleType: 'foo'
 * //   }
 * @example
 * // Multiple properties
 * listStyle({type: 'foo', position: 'bar'});
 * // → {
 * //     listStyleType: 'foo',
 * //     listStylePosition: 'bar'
 * //   }
 */
var listStyle = shorthand({
  type: 'listStyleType',
  position: 'listStylePosition',
  image: 'listStyleImage'
});

/**
 * Directional margin helper
 * @function margin
 * @param  {number|string|object} value         Value for all directions or object of values:
 * @param  {number|string}       [value.x]      Left and right value
 * @param  {number|string}       [value.y]      Top and bottom value
 * @param  {number|string}       [value.top]    Top value (takes precedence over y)
 * @param  {number|string}       [value.right]  Right value (takes precedence over x)
 * @param  {number|string}       [value.bottom] Bottom value (takes precedence over y)
 * @param  {number|string}       [value.left]   Left value (takes precedence over x)
 * @return {object}                             Style object
 * @example
 * // All directions
 * margin('foo');
 * // → {
 * //     marginTop: 'foo',
 * //     marginRight: 'foo',
 * //     marginBottom: 'foo',
 * //     marginLeft: 'foo'
 * //   }
 * @example
 * // A single axis
 * margin({x: 'bar'});
 * // → {
 * //     marginLeft: 'bar',
 * //     marginRight: 'bar'
 * //   }
 * @example
 * // Any combination
 * margin({y: 'foo', top: 'bar', right: 'baz'});
 * // → {
 * //     marginTop: 'bar',
 * //     marginRight: 'baz',
 * //     marginBottom: 'foo'
 * //   }
 */
var margin = directional(
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft'
);

/**
 * Shorthand outline helper
 * @function outline
 * @param  {object}         value
 * @param  {number|string} [value.width] outline width value
 * @param  {number|string} [value.style] outline style value
 * @param  {number|string} [value.color] outline color value
 * @return {object}                       Style object
 * @example
 * // A single property
 * outline({width: 'foo'});
 * // → {
 * //     outlineWidth: 'foo'
 * //   }
 * @example
 * // Multiple properties
 * outline({width: 'foo', style: 'bar'});
 * // → {
 * //     outlineWidth: 'foo',
 * //     outlineStyle: 'bar'
 * //   }
 */
var outline = shorthand({
  width: 'outlineWidth',
  style: 'outlineStyle',
  color: 'outlineColor'
});

/**
 * Directional padding helper
 * @function padding
 * @param  {number|string|object} value         Value for all directions or object of values:
 * @param  {number|string}       [value.x]      Left and right value
 * @param  {number|string}       [value.y]      Top and bottom value
 * @param  {number|string}       [value.top]    Top value (takes precedence over y)
 * @param  {number|string}       [value.right]  Right value (takes precedence over x)
 * @param  {number|string}       [value.bottom] Bottom value (takes precedence over y)
 * @param  {number|string}       [value.left]   Left value (takes precedence over x)
 * @return {object}                             Style object
 * @example
 * // All directions
 * padding('foo');
 * // → {
 * //     paddingTop: 'foo',
 * //     paddingRight: 'foo',
 * //     paddingBottom: 'foo',
 * //     paddingLeft: 'foo'
 * //   }
 * @example
 * // A single axis
 * padding({x: 'bar'});
 * // → {
 * //     paddingLeft: 'bar',
 * //     paddingRight: 'bar'
 * //   }
 * @example
 * // Any combination
 * padding({y: 'foo', top: 'bar', right: 'baz'});
 * // → {
 * //     paddingTop: 'bar',
 * //     paddingRight: 'baz',
 * //     paddingBottom: 'foo'
 * //   }
 */
var padding = directional(
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft'
);

/**
 * Shorthand transition helper
 * @function transition
 * @param  {object}         value
 * @param  {number|string} [value.property]       transition property value
 * @param  {number|string} [value.duration]       transition duration value
 * @param  {number|string} [value.timingFunction] transition timingFunction value
 * @param  {number|string} [value.delay]          transition delay value
 * @return {object}                                Style object
 * @example
 * // A single property
 * transition({property: 'foo'});
 * // → {
 * //     transitionProperty: 'foo'
 * //   }
 * @example
 * // Multiple properties
 * transition({property: 'foo', duration: 'bar'});
 * // → {
 * //     transitionProperty: 'foo',
 * //     transitionDuration: 'bar'
 * //   }
 */
var transition = shorthand({
  property: 'transitionProperty',
  duration: 'transitionDuration',
  timingFunction: 'transitionTimingFunction',
  delay: 'transitionDelay'
});

export { animation, background, border, borderColor, borderImage, borderRadius, borderStyle, borderWidth, flex, font, listStyle, margin, outline, padding, transition };


//////////////////
// WEBPACK FOOTER
// ./node_modules/lostyle/dist-es/index.js
// module id = 3
// module chunks = 0